<template>
  <div>
    <b-card>
      <a :href="previewImageUrl" target="_blank">
        <img :src="previewImageUrl" :style="{ 'max-width': '100%', 'height': 'auto', 'max-height': `${previewHeight}px`}" />
      </a>
    </b-card>

    <dx-file-uploader ref="fileUploader"
      label-text=""
      accept="image/*"
      :allowed-file-extensions="['.jpg', '.jpeg', '.gif', '.png']"
      upload-mode="useButtons"
      :upload-url="baseUrl + uploadUrl"
      :upload-headers="authorizationHeader"
      :show-file-list="false"
      :visible="false"
      @valueChanged="valueChanged" />

    <b-button class="mt-3" variant="secondary" size="sm"
              @click="selectFile()">
      <font-awesome-icon :icon="['fas', 'folder-open']" /> {{ $t('Webportal.SelectFile') }}
    </b-button>

    <b-button class="mt-3" variant="secondary" size="sm"
              @click="deleteFile()">
      <font-awesome-icon :icon="['fas', 'trash-alt']" /> {{ $t('Webportal.Delete') }}
    </b-button>
  </div>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'
import { DxFileUploader } from 'devextreme-vue';
import axios from 'axios';

export default {
  name: "ImageUploader",

  props: {
    uploadUrl: {
      type: String,
      default: '/'
    },
    previewHeight: {
      type: Number,
      default: 100
    },
    value: {
      type: String,
      default: null
    }
  },

  components : {
    DxFileUploader
  },

  data() {
    return {
      uploadImageUrl: null
    }
  },

  computed: {
    baseUrl() {
      return process.env.BASE_URL 
    },

    authorizationHeader() {
      return AuthenticationService.authorizationHeader;
    },

    previewImageUrl() {
      return this.uploadImageUrl ? window.URL.createObjectURL(this.uploadImageUrl) : this.value;
    },
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal)
      {
        this.$refs.fileUploader.instance.reset();
        this.uploadImageUrl = null;
      }
    },
  },
  
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    valueChanged(event) {
      this.uploadImageUrl = event && event.value && event.value.length > 0 ? event.value[0] : null;
      if (this.uploadImageUrl)
        this.onInput(null);
    },

    selectFile() {
      let selectButton = this.$refs.fileUploader.$el
        .getElementsByClassName("dx-fileuploader-input-wrapper")[0]
        .getElementsByClassName("dx-fileuploader-button");

      if (selectButton)
      {
        selectButton[0].click();
      }
    },

    deleteFile() {
      this.$refs.fileUploader.instance.reset();
      this.uploadImageUrl = null;
      this.onInput(null);
    },

    uploadImage() {
      let fileUploader = this.$refs.fileUploader;

      if (fileUploader.instance._files.length > 0)
      {
        // Enable retry
        for (var i = 0; i < fileUploader.instance._files.length; i++) {
          delete fileUploader.instance._files[i].uploadStarted;
        }

        let uploadButton = fileUploader.$el.getElementsByClassName("dx-fileuploader-button dx-fileuploader-upload-button");
        if (uploadButton)
          uploadButton[0].click();
      }
      else
      {
        // Delete picture
        axios.post(process.env.BASE_URL + this.uploadUrl);
      }
    }
  }
}
</script>